import React, { useCallback, useEffect, useState } from "react";
import {
  ReactFlow,
  applyEdgeChanges,
  applyNodeChanges,
  Controls,
  Background,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";

const NodeGraph2 = ({ workflow, onClose = () => {} }) => {
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);

  useEffect(() => {
    if (workflow) {
      console.log("!!! WORKFLOW: ", workflow);
      const newNodes = [];
      const graphNodes = Object.values(workflow.graph.nodes);
      if (graphNodes) {
        graphNodes.forEach((node) => {
          newNodes.push({
            id: node.graph_id,
            position: { x: node.x / 2, y: node.y / 2 },
            data: { label: node.name },
          });
        });
      }
      setNodes(newNodes);

      const newEdges = [];
      const graphEdges = Object.values(workflow.graph.edges);
      if (graphEdges) {
        graphEdges.forEach((edge, index) => {
          console.log("!!! EDGE: ", edge);
          newEdges.push({
            id: index,
            source: edge.output.graph_id,
            target: edge.input.graph_id,
            label: edge.output.key,
            type: "straight",
          });
        });
      }

      console.log("!!! EDGES: ", newEdges);
      setEdges(newEdges);
    }
    // eslint-disable-next-line
  }, []);

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    []
  );
  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    []
  );

  if (nodes.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ height: "100%" }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        fitView
      >
        <Background />
        <Controls />
      </ReactFlow>
    </div>
  );
};

export default NodeGraph2;
